/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Supported kinds of payment.   (german: Zahlungsart)   (bipro-datentypen::Zahlungsart)     * `Debit`     - german: Lastschrift   * `Transfer`  - german: Überweisung
 */
export const PaymentMethod = {
  Debit: 'Debit',
  Transfer: 'Transfer',
} as const;
export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];
